import * as React from 'react';
import LinkButton from '../LinkButton/LinkButton';
import S from './MobileFloatingCta.styles';
const MobileFloatingCta = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(S.Container, null,
            React.createElement(LinkButton, { buttonType: "default", href: props.url, target: props.target }, props.text))));
};
export default MobileFloatingCta;
